<template>
  <div v-loading="loading">
    <div class="fx">
      <div class="chart fx-full">
        <img src="@/assets/panel/dash-board.png" alt="" srcset="" class="chart-bg">
        <MyEcharts ref="myEchart" style="width: 100%;height:240px;" />
      </div>
      <div class="fx-full info-box pt-60">
        <el-descriptions :column='1'>
          <el-descriptions-item label="科创分" labelClassName="label">
            <div class="value">{{scoreTotalLevel}}</div>
          </el-descriptions-item>
          <el-descriptions-item label="所属国标行业" labelClassName="label">
            <div class="value">{{industryName}}</div>
          </el-descriptions-item>
          <el-descriptions-item label="行业排名" labelClassName="label">
            <div class="value"> 超过了 {{kcfExceedRank}} %的同行企业</div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>

    <div>
      <div class="el-row" style="margin-left: -10px; margin-right: -10px;">
        <div class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;">
          <div class="sub-option">
            <span class="icon cust-icon cust-icon-svg" :title="`企业科创评分：${scoreTotalLevel}`">
              <img src="@/assets/panel/1.svg" alt="" srcset="" class="chart-bg">
            </span>
            <label class="fx-none" title="企业科创评分">企业科创评分</label>
            <div class="score">
              <div class=""><span class="val">{{scoreTotalLevel}}</span></div>
            </div>
          </div>
        </div>
        <div class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;">
          <div class="sub-option">
            <span class="icon cust-icon cust-icon-svg" :title="`企业科创排位：${topRank}`">
              <img src="@/assets/panel/2.svg" alt="" srcset="" class="chart-bg">
            </span>
            <label class="fx-none" title="企业科创排位">企业科创排位</label>
            <div class="score">
              <div class="bot"><span class="pre">前</span><span class="val">{{topRank}}</span></div><span class="append">全国同行业企业</span>
            </div>
          </div>
        </div>
        <div class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;">
          <div class="sub-option">
            <span class="icon cust-icon cust-icon-svg" :title="`企业科创评价：${levelObj[kcfLevel] || '--'}`">
              <img src="@/assets/panel/3.svg" alt="" srcset="" class="chart-bg">
            </span>
            <label class="fx-none" title="企业科创评价">企业科创评价</label>
            <div class="score">
              <div class="bot"><!----><span class="val">{{kcfLevel}}</span></div><span class="append">{{levelObj[kcfLevel]|| '--'}}</span>
            </div>
          </div>
        </div>
        <div class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;">
          <div class="sub-option">
            <span class="icon cust-icon cust-icon-svg" :title="`同行业评分：${kcfAvg}`">
              <img src="@/assets/panel/4.svg" alt="" srcset="" class="chart-bg">
            </span>
            <label class="fx-none" title="同行业评分">同行业评分</label>
            <div class="score">
              <div class=""><!----><span class="val">{{kcfAvg}}</span></div><!---->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="mid-title">分项评价</div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="key" label="分项维度" width="width"></el-table-column>
        <el-table-column prop="value1" label="分项评分" width="width"></el-table-column>
        <el-table-column prop="value2" label="分项等级" width="width"></el-table-column>
        <el-table-column prop="value3" label="分项排位" width="width"></el-table-column>
        <el-table-column prop="value4" label="同行业平均分" width="width"></el-table-column>
      </el-table>
    </div>
    <div class="mid-title mt-16">同行业对比</div>
    <div class="fx">
      <MyEcharts ref="myEchart2" class="fx-full" style="height:380px;" />
    </div>

    <div class="fx-full rank-list mt-16">
      <div class="content">
        <p><b>将企业的评估维度与行业各值进行横向对比分析发现，该企业</b></p>
        <div class="sub-rank">
          <div> 知识产权能力 {{handleRank(rateData.zscqRank)}}，在同行业中位于前 <span style="color: rgb(220, 64, 64);">{{rateData.zscqRank}}</span>; </div>
        </div>
        <div class="sub-rank">
          <div> 科技资质能力 {{handleRank(rateData.kjzzRank)}}，在同行业中位于前 <span style="color: rgb(220, 64, 64);">{{rateData.kjzzRank}}</span>; </div>
        </div>
        <div class="sub-rank">
          <div> 研发能力能力 {{handleRank(rateData.yfnlRank)}}，在同行业中位于前 <span style="color: rgb(220, 64, 64);">{{rateData.yfnlRank}}</span>; </div>
        </div>
        <!-- <div class="sub-rank">
          <div> 行业发展能力 处于行业中游水平，在同行业中位于前 <span style="color: rgb(220, 64, 64);">52.00%</span>; </div>
        </div> -->
        <div class="sub-rank">
          <div> 成长潜力能力 {{handleRank(rateData.czqlRank)}}，在同行业中位于前 <span style="color: rgb(220, 64, 64);">{{rateData.czqlRank}}</span>; </div>
        </div>
        <div class="sub-rank">
          <div> 财税规模能力 {{handleRank(rateData.csgmRank)}}，在同行业中位于前 <span style="color: rgb(220, 64, 64);">{{rateData.csgmRank}}</span>; </div>
        </div>
        <div class="sub-rank">
          <div> 履约信用能力 {{handleRank(rateData.lyxyRank)}}，在同行业中位于前 <span style="color: rgb(220, 64, 64);">{{rateData.lyxyRank}}</span>; </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyEcharts from '@/components/myEcharts'
import { scienceChart, industryRadar } from '@/views/clue/components/echartsOptions'
import EnterpriseSub from '@/views/clue/components/enterpriseSub'
import {
  getStisCategory,
} from '@/views/clue/api/newClueApi'
export default {
  name: 'EnterpriseScience',
  components: {
    MyEcharts,
    EnterpriseSub
  },
  props: {},
  inject: ['$companyStatus'],
  data() {
    return {
      rateData: {},
      hid: '',
      scoreVO: [],
      loading: false,
      tableData: [],
      levelObj: {
        S: '卓越', A: '优异', B: '优秀', C: '良好', D: '一般', E: '欠缺'
      }
    }
  },
  computed: {
    scoreTotalLevel() { return this.formatFelid(this.rateData?.kcf) },
    kcfExceedRank() { return this.formatFelid(this.rateData?.kcfExceedRank) },
    industryName() { return this.formatFelid(this.rateData?.subindusty) },
    kcfLevel() { return this.formatFelid(this.rateData?.kcfLevel) },
    kcfAvg() { return this.formatFelid(this.rateData?.kcfAvg) },
    topRank() { return this.formatFelid(this.rateData?.topRank) },
    flipKcfExceedRank() {
      if (this.kcfExceedRank) {
        return (10000 - this.kcfExceedRank * 100) / 100 + '%'
      }
      return '--'
    }
  },
  watch: {
    '$companyStatus.hid': {
      immediate: true,
      handler: function (hid) {
        hid && this.enterpriseEvaluate(hid)
      }
    }
  },
  mounted() {
  },
  methods: {
    initMap(grade, companyScore, mean) {
      this.$refs.myEchart?.update(scienceChart(grade || 0))
      this.$refs.myEchart2?.update(industryRadar(this.rankList(companyScore, mean)))
    },

    rankList(companyScore, mean) {

      this.industrySubScore = {
        "mean": mean,
        "stddev": [
          "16",
          "20",
          "9",
          "31",
          "6",
          "18",
          "8"
        ],
        "median": [
          "19",
          "8",
          "0",
          "96",
          "13",
          "48",
          "93"
        ],
        "max": [
          "93",
          "100",
          "99",
          "100",
          "82",
          "96",
          "100"
        ],
        "min": [
          "1",
          "0",
          "0",
          "0",
          "1",
          "13",
          "21"
        ]
      }

      this.companyScore = companyScore || ['35', '0', '0', '83', '21', '73', '93']
      // 其他维度 没有数据做不了
      return [{
        name: "本公司",
        rankKey: "mean",
        color: "#327CFE",
        symbolSize: 5,
        value: this.companyScore,
        itemStyle: {
          borderWidth: 6,
          borderType: "dashed"
        }
      },
      {
        name: "行业平均值",
        rankKey: "mean",
        color: "#8EC320",
        value: this.industrySubScore.mean,
        symbolSize: 5,
        lineStyle: {
          type: "dashed"
        }
      },
        //  {
        //   name: "行业标准差",
        //   rankKey: "stddev",
        //   color: "#FFB355",
        //   value: this.industrySubScore.stddev,
        //   symbolSize: 5,
        //   lineStyle: {
        //     type: "dashed"
        //   }
        // }, {
        //   name: "行业中位数",
        //   rankKey: "median",
        //   color: "#F86E60",
        //   value: this.industrySubScore.median,
        //   symbolSize: 5,
        //   lineStyle: {
        //     type: "dashed"
        //   }
        // }, {
        //   name: "行业最大值",
        //   rankKey: "max",
        //   color: "#6EE1F5",
        //   value: this.industrySubScore.max,
        //   symbolSize: 5,
        //   lineStyle: {
        //     type: "dashed"
        //   }
        // }, {
        //   name: "行业最小值",
        //   rankKey: "min",
        //   color: "#886EF5",
        //   value: this.industrySubScore.min,
        //   symbolSize: 5,
        //   lineStyle: {
        //     type: "dotted"
        //   }
        // }
      ]
    },
    handleRank(t) {
      if (t == undefined) return
      t = parseFloat(t)
      t == 0 ? t = '1' : t = String(Math.ceil(t / 20))
      switch (t) {
        case "1":
          return "处于行业上游水平"
        case "2":
          return "处于行业中上水平"
        case "3":
          return "处于行业中游水平"
        case "4":
          return "处于行业中下游水平"
        default:
          return "处于行业下游水平"
      }
    },
    async enterpriseEvaluate(hid) {
      // this.loading = true
      let { data = {}, code } = await getStisCategory({ hid })
      if (code === 200) {
        data = data || {}
        data.kcfAvg = this.formatFelid(data.kcfAvg)
        data.kjzzAvg = this.formatFelid(data.kjzzAvg)
        data.lyxyAvg = this.formatFelid(data.lyxyAvg)
        data.yfnlAvg = this.formatFelid(data.yfnlAvg)
        data.czqlAvg = this.formatFelid(data.czqlAvg)
        data.zscqAvg = this.formatFelid(data.zscqAvg)
        data.csgmAvg = this.formatFelid(data.csgmAvg)
        this.rateData = data

        this.tableData = [
          { key: '知识产权', value1: data.zscq, value2: data.zscqLevel, value3: data.zscqRank, value4: data.zscqAvg, },
          { key: '科技资质', value1: data.kjzz, value2: data.kjzzLevel, value3: data.kjzzRank, value4: data.kjzzAvg, },
          { key: '研发能力', value1: data.yfnl, value2: data.yfnlLevel, value3: data.yfnlRank, value4: data.yfnlAvg, },
          // { key: '行业发展', value1: data.zscq, value2: data.zscqLevel, value3: data.zscqRank, value4: data.zscqAvg, },
          { key: '成长潜力', value1: data.czql, value2: data.czqlLevel, value3: data.czqlRank, value4: data.czqlAvg, },
          { key: '财税规模', value1: data.csgm, value2: data.csgmLevel, value3: data.csgmRank, value4: data.csgmAvg, },
          { key: '履约信用', value1: data.lyxy, value2: data.lyxyLevel, value3: data.lyxyRank, value4: data.lyxyAvg, },
        ]
        this.initMap(data.kcf, [data.zscq, data.kjzz, data.yfnl, data.czql, data.csgm, data.lyxy],
          [data.zscqAvg, data.kjzzAvg, data.yfnlAvg, data.czqlAvg, data.csgmAvg, data.lyxyAvg])
      }
    },

    formatFelid(val) {
      if (typeof val === 'number') return this.truncateDecimals(val, 2)
      if (typeof val === 'string') return this.truncateDecimals(val, 2)
      if (!val) return '--'
      return val
    },
    truncateDecimals(num, digits) {
      var numStr = num.toString();
      var decimalIndex = numStr.indexOf('.');

      if (decimalIndex !== -1) {
        return parseFloat(numStr.slice(0, decimalIndex + digits + 1));
      } else {
        return num
      }
    }
  }
}
</script>

<style scoped lang="scss">
.mid-title {
  background: #f9fafe;
  font-size: 16px;
  font-weight: 600;
  padding: 8px;
}
.info-box {
  ::v-deep .label {
    font-weight: 400;
    color: #86909c;
    flex-shrink: 0;
  }
  .value {
    font-weight: 500;
    color: #586474;
  }
}
.chart {
  // width: 100%;
  position: relative;
  .chart-bg {
    position: absolute;
    height: 200px;
    left: 50%;
    top: 0;
    transform: translate(-50%);
  }
}
.rank-list {
  font-size: 14px;
}
.sub-rank {
  margin-top: 8px;
  margin-bottom: 8px;
}
.sub-option {
  height: 90px;
  margin-bottom: 20px;
  background: #f9fafe;
  font-size: 16px;
  padding: 10px 20px;
  font-weight: 400;
  color: #4b4b4b;
  display: flex;
  align-items: center;
}

.sub-option .icon {
  display: inline-block;
  height: 48px;
  width: 48px;
  font-size: 0;
  line-height: 48px;
}

.sub-option label {
  flex: 1;
  padding: 0 5px 0 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.sub-option .score {
  // height: 47px;
  font-size: 24px;
  font-weight: 700;
  color: #1b253a;
  text-align: right;
  max-width: 120px;
}

.sub-option .score .pre {
  color: #1c212a;
  margin-right: 10px;
}

.sub-option .score .append,
.sub-option .score .pre {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.sub-option .score .append {
  display: inline-block;
  white-space: nowrap;
  height: 20px;
  color: #8a8a8a;
}
</style>
